<template>
  <div>
    <slot v-if="!subscribed" name="form" :subscription="subscription" :subscribe="subscribe" />
    <slot v-else name="thank-you" />
  </div>
</template>

<script>
import axios from '../../common/http/axios';

export default {
  props: {
    url: { required: true, type: String }
  },

  data() {
    return {
      subscribed: false,
      subscription: {
        email: ''
      }
    };
  },

  methods: {
    async subscribe() {
      if (this.subscribed) return;

      // Optimistic approach here, we believe errors don't happen 😬️
      await axios.post(this.url, this.subscription);

      this.subscribed = true;
    }
  }
};
</script>
